import React, { useState } from 'react';
import { carrierApi } from '../../firebase/functionsService';
import { normalizeNorwegianPhone, formatPhone } from '../../utils/phone';
import { CARRIER_ROLE_LABEL, createRolesFor, inviteRolesFor } from '../../utils/carrierRoles';
import Field from './Field';
import { ui } from './carrierStyles';

// Oppretter en sjåfør eller dispatcher som logger inn med mobilnummer og SMS-kode.
//   callerRole: rollen til den som oppretter (styrer hvilke roller som kan velges)
//   onDone(message): kalles med en bekreftelsestekst
export function CreateMemberForm({ orgId, callerRole, onDone }) {
  const roles = createRolesFor(callerRole);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState(roles[0]);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  async function submit(e) {
    e.preventDefault();
    const found = {};
    if (name.trim().length < 2) found.name = 'Skriv inn navn';
    if (!normalizeNorwegianPhone(phone)) found.phone = 'Skriv inn et norsk mobilnummer';
    setErrors(found);
    if (Object.keys(found).length > 0) return;
    setStatus('saving');
    setMessage('');
    try {
      const res = await carrierApi.createOrgMember({ orgId, name, phone, role });
      setName('');
      setPhone('');
      setStatus('idle');
      if (onDone) onDone(`${name.trim()} kan nå logge inn med SMS-kode på ${formatPhone(res.phone)}.`);
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Kunne ikke opprette');
    }
  }

  return (
    <form onSubmit={submit} noValidate>
      <p style={ui.hint}>Personen logger inn med mobilnummeret og en SMS-kode. Hen trenger verken e-post eller passord.</p>
      <Field id="cm-name" label="Navn" error={errors.name}>
        <input id="cm-name" style={ui.input} value={name} onChange={e => setName(e.target.value)} maxLength={80} autoComplete="off" />
      </Field>
      <Field id="cm-phone" label="Mobilnummer" error={errors.phone}>
        <input id="cm-phone" style={ui.input} value={phone} onChange={e => setPhone(e.target.value)} inputMode="tel" autoComplete="off" />
      </Field>
      {roles.length > 1 && (
        <Field id="cm-role" label="Rolle">
          <select id="cm-role" style={ui.input} value={role} onChange={e => setRole(e.target.value)}>
            {roles.map(r => <option key={r} value={r}>{CARRIER_ROLE_LABEL[r]}</option>)}
          </select>
        </Field>
      )}
      {status === 'error' && <p role="alert" style={ui.error}>{message}</p>}
      <button type="submit" className="tippi-btn" style={{ ...ui.btn, marginTop: 14 }} disabled={status === 'saving'}>
        {status === 'saving' ? 'Oppretter…' : 'Opprett'}
      </button>
    </form>
  );
}

// Inviterer en som allerede har en Tippi-konto, via e-post. Personen svarer i appen.
export function InviteMemberForm({ orgId, callerRole, onDone }) {
  const roles = inviteRolesFor(callerRole);
  const [email, setEmail] = useState('');
  const [role, setRole] = useState(roles[0]);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  async function submit(e) {
    e.preventDefault();
    const found = {};
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) found.email = 'Skriv inn en gyldig e-postadresse';
    setErrors(found);
    if (Object.keys(found).length > 0) return;
    setStatus('saving');
    setMessage('');
    try {
      await carrierApi.inviteCarrierMember({ orgId, email: email.trim(), role });
      const sentTo = email.trim();
      setEmail('');
      setStatus('idle');
      if (onDone) onDone(`Invitasjon sendt til ${sentTo}.`);
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Kunne ikke sende invitasjonen');
    }
  }

  return (
    <form onSubmit={submit} noValidate>
      <p style={ui.hint}>For personer som allerede har en Tippi-konto. De får et varsel i appen og svarer selv.</p>
      <Field id="im-email" label="E-post" error={errors.email}>
        <input id="im-email" type="email" style={ui.input} value={email} onChange={e => setEmail(e.target.value)} autoComplete="off" />
      </Field>
      <Field id="im-role" label="Rolle">
        <select id="im-role" style={ui.input} value={role} onChange={e => setRole(e.target.value)}>
          {roles.map(r => <option key={r} value={r}>{CARRIER_ROLE_LABEL[r]}</option>)}
        </select>
      </Field>
      {status === 'error' && <p role="alert" style={ui.error}>{message}</p>}
      <button type="submit" className="tippi-btn" style={{ ...ui.btn, marginTop: 14 }} disabled={status === 'saving'}>
        {status === 'saving' ? 'Sender…' : 'Send invitasjon'}
      </button>
    </form>
  );
}
